<ng-container *ngComponentOutlet="rowcomponent; injector: getInjector(item)"></ng-container>